import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate, Flex, Checkbox, Button, ButtonGroup, Icon } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { sendAdminInvitation, setEmailSentList, getAdminInvitations } from '../../../actions/services';
import { Spinner } from 'UI';
import getEnvironment from 'lib/env';
import '../_onboarding.scss';
import { addError } from 'actions';
import { appInsights } from 'lib/appInsights';
import * as microsoftTeams from "@microsoft/teams-js";
import moment from 'moment';

var EmailAdminInvite = /*#__PURE__*/function (_Component) {
  _inherits(EmailAdminInvite, _Component);

  var _super = _createSuper(EmailAdminInvite);

  function EmailAdminInvite(props) {
    var _this;

    _classCallCheck(this, EmailAdminInvite);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "goBack", function () {
      return new Promise(function (resolve) {
        if (_this.props.onSubmit) {
          _this.props.onSubmit(0).then(function () {
            resolve(1);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: "1px solid red"
        } : {},
        onKeyPress: function onKeyPress(e) {
          if (e.key == 'Enter') {
            e.preventDefault();
          }
        }
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          margintop: "1rem",
          color: "red"
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          margintop: "1rem",
          color: "red"
        }
      }, warning)));
    });

    _this.state = {
      isLoading: false,
      showEmailInfo: false,
      showConsentInfo: true,
      showEmailSentInfo: false,
      adminEmail: null,
      recpients: [],
      errorMessage: null,
      inviteRetry: 0,
      emailBody: '',
      user: {
        name: '',
        email: ''
      }
    };
    window.onPopupDataReceived = _this.getResults.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(EmailAdminInvite, [{
    key: "getResults",
    value: function getResults(response) {
      console.log("CONSENT MAIL", response);

      if (response) {
        this.onAdminInvite({
          email: this.state.recpients.join(",")
        });
      }
    }
  }, {
    key: "inIframe",
    value: function inIframe() {
      try {
        return window.self !== window.top || window.navigator.userAgent.indexOf('TeamsMobile') > -1;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      appInsights.trackTrace({
        message: "Onboarding | Invite Admin was initiated"
      });

      if (this.inIframe()) {
        microsoftTeams.app.getContext().then(function (context) {
          console.log("context", context);

          if (context.user.userPrincipalName) {
            var user = _this2.state.user;
            user.email = context.user.userPrincipalName;
            user.name = context.user.userPrincipalName.split('@')[0];

            if (user.name.indexOf(".") > -1) {
              var firstName = user.name.split('.')[0];
              var lastName = user.name.split('.')[1];
              firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
              lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1);
              user.name = firstName + " " + lastName;
            }

            _this2.setState({
              user: user
            });

            _this2.prepareEmailBody();
          }
        });
      } else {
        if (this.props.onboardingUser) {
          var user = this.state.user;
          user.email = this.props.onboardingUser.email;
          user.name = this.props.onboardingUser.email.split('@')[0];

          if (user.name.indexOf(".") > -1) {
            var firstName = user.name.split('.')[0];
            var lastName = user.name.split('.')[1];
            firstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
            lastName = lastName.charAt(0).toUpperCase() + lastName.slice(1);
            user.name = firstName + " " + lastName;
          }

          this.setState({
            user: user
          });
          this.prepareEmailBody();
        }
      }
    }
  }, {
    key: "prepareEmailBody",
    value: function prepareEmailBody() {
      var product = getEnvironment().id;
      var emailBody = this.props.translate("ONBOARDING_PLANNING_EMAIL_ADMIN");
      console.log(emailBody);
      emailBody = emailBody.replace(/\{0\}/g, this.getSelectedServicesInString());
      emailBody = emailBody.replace(/\{1\}/g, "https://appsource.microsoft.com/sv-se/product/office/haldorab-4682854.haldor_planning?tab=Overview");
      var today = moment();
      var date30DaysAhead = today.add(30, 'days');
      emailBody = emailBody.replace(/\{2\}/g, date30DaysAhead.format('YYYY-MM-DD'));
      emailBody = emailBody.replace(/\{3\}/g, window.location.origin + '/onboarding?admin=1&product=' + product);
      emailBody = emailBody.replace(/\{4\}/g, this.state.user.name);
      emailBody = emailBody.replace(/\{5\}/g, this.state.user.email);
      emailBody = emailBody.replace(/\{6\}/g, moment().format('YYYY-MM-DD'));
      this.setState({
        emailBody: emailBody
      });
    }
  }, {
    key: "onAdminInvite",
    value: function onAdminInvite(values) {
      var _this3 = this;

      var product = getEnvironment().id;
      console.log("Email", values);
      console.log("retry", this.state.inviteRetry);
      this.setState({
        errorMessage: null
      });
      window.scrollTo(0, document.body.scrollHeight);

      if (values == null || values.email == null) {
        emailInvalid = this.props.translate("Email is invalid, please provide correct email");
        this.setState({
          errorMessage: emailInvalid
        });
      } else {
        values.email = values.email.replace(",", ";");
        var emailList = values.email.split(";");
        var emailHandledList = [];
        var emailInvalid = null;
        emailList.forEach(function (element) {
          element = element.replace(/\s/g, '');

          if (_this3.validateEmail(element)) {
            emailHandledList.push(element);
          } else {
            emailInvalid = _this3.props.translate("Email is invalid, please provide correct email");
          }
        });
        this.setState({
          errorMessage: emailInvalid
        });

        if (emailHandledList.length > 0 && emailInvalid == null) {
          var adminInviteInfo = {
            recpients: emailList,
            redirect_url: window.location.origin + '/onboarding?admin=1&product=' + product,
            subscriptionService: product
          };
          this.setState({
            recpients: emailList,
            inviteRetry: this.state.inviteRetry + 1,
            isLoading: true
          });
          this.props.setEmailSentList(emailList);

          if (emailHandledList != null && emailHandledList.length > 0 && this.state.inviteRetry < 3) {
            appInsights.trackTrace({
              message: "Onboarding | Sending Invitation to Admin"
            });
            this.props.sendAdminInvitation(adminInviteInfo).then(function (response) {
              // This will make sure to get data about information of sent invitations
              _this3.props.getAdminInvitations();

              if (_this3.props.inviteAdminStatus != 200) {
                if (_this3.state.inviteRetry == 2) {
                  _this3.setState({
                    isLoading: false
                  });
                }

                _this3.getEmailConsent();
              } else {
                _this3.setState({
                  isLoading: false
                });

                _this3.props.showPage('showEmailSentInfo');
              }
            });
          }
        }
      }
    }
  }, {
    key: "getEmailConsent",
    value: function getEmailConsent() {
      var _this4 = this;

      if (this.props.onboardingUser) {
        appInsights.trackTrace({
          message: "Onboarding | Opening ms admin outh url"
        });
        var consentTab = window.open("https://login.microsoftonline.com/" + this.props.onboardingUser.tenantId + "/oauth2/v2.0/authorize?client_id=" + getEnvironment().apiClientId + "&response_type=token&scope=user.read%20mail.send&redirect_uri=" + window.location.origin + "/teams/he/authentication", "_blank", "width=600,height=1200");
        var timer = setInterval(function () {
          if (consentTab.closed) {
            _this4.setState({
              isLoading: false
            });

            clearInterval(timer);
          }
        }, 1000);
        return;
      }
    }
  }, {
    key: "showEmailHeader",
    value: function showEmailHeader() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        style: {
          textAlign: 'left'
        }
      }, this.props.translate('Move forward with admin approval')), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'left',
          marginTop: '1rem',
          marginBottom: '5%'
        }
      }, this.props.translate('We\'ve prepared an email draft for you. Simply enter the admin\'s email address or copy the text into your email client. Once ready, send it off!')));
    }
  }, {
    key: "showEmailBody",
    value: function showEmailBody() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("form", {
        className: "form form-component",
        onSubmit: this.props.handleSubmit(this.onAdminInvite.bind(this))
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row input"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: '20rem',
          height: '20rem'
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: "/dist/svg/illustration_steg03.svg"
      })), /*#__PURE__*/React.createElement("label", null, this.props.translate("to")), /*#__PURE__*/React.createElement("p", null, this.props.translate('To send the e-mail to multiple recipients, enter the addresses and separate them with semicolons or commas.')), /*#__PURE__*/React.createElement(Field, {
        component: this.renderInput,
        type: "text",
        name: "email",
        placeholder: this.props.translate("to")
      }), /*#__PURE__*/React.createElement("div", {
        className: "email-container"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, this.props.translate("A copy of this email is sent to:")), " ", this.state.user.email), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, this.props.translate("Subject"), ":"), " ", this.props.translate('Approval of Haldor Education'), " "), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, this.props.translate("E-mail message:"))), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, this.props.translate("Please review the admin consent request for Haldor Planning."))), /*#__PURE__*/React.createElement("p", {
        id: "email-body",
        dangerouslySetInnerHTML: {
          __html: this.state.emailBody
        }
      })), this.showEmailButtonGroup())));
    }
  }, {
    key: "copyTextToClipboard",
    value: function copyTextToClipboard() {
      var text = document.getElementById("email-body").innerText;
      var elem = document.createElement("textarea");
      document.body.appendChild(elem);
      elem.innerHTML = text;
      elem.select();
      document.execCommand("copy");
      document.body.removeChild(elem);
    }
  }, {
    key: "showEmailButtonGroup",
    value: function showEmailButtonGroup() {
      var _this5 = this;

      return /*#__PURE__*/React.createElement("div", null, this.state.errorMessage ? /*#__PURE__*/React.createElement("p", {
        style: {
          color: "red",
          marginBottom: '0.5rem'
        }
      }, this.state.errorMessage) : null, /*#__PURE__*/React.createElement(Button, {
        type: "save",
        style: {
          marginRight: '0.5rem'
        }
      }, this.props.translate('Send')), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginRight: '0.5rem'
        },
        onClick: function onClick(event) {
          event.preventDefault();

          _this5.copyTextToClipboard();

          _this5.props.addError(_this5.props.translate('The text was copied'), 'info');
        }
      }, this.props.translate('Copy Text')), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginRight: '0.5rem'
        },
        onClick: function onClick() {
          _this5.props.showPage('showConsentInfo');
        }
      }, this.props.translate('Back')));
    }
  }, {
    key: "validateEmail",
    value: function validateEmail(email) {
      var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

      if (!pattern.test(email)) {
        return false;
      }

      return true;
    }
  }, {
    key: "getSelectedServicesInString",
    value: function getSelectedServicesInString() {
      var _this6 = this;

      var serviceNames = this.props.selectedServices.map(function (element, index) {
        var text = _this6.props.translate(element.name);

        return text;
      });
      return serviceNames.join(", ");
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, this.state.isLoading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement("div", null, this.showEmailHeader(), this.showEmailBody()));
    }
  }]);

  return EmailAdminInvite;
}(Component);

_defineProperty(EmailAdminInvite, "contextTypes", {
  router: PropTypes.object
});

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    selectedServices: state.Services.selectedServices,
    consentInfo: state.Services.consentInfo,
    inviteAdminStatus: state.Services.inviteAdminStatus,
    onboardingUser: state.user.onboardingUser
  };
}

export default connect(mapStateToProps, {
  sendAdminInvitation: sendAdminInvitation,
  setEmailSentList: setEmailSentList,
  getAdminInvitations: getAdminInvitations,
  addError: addError
})(reduxForm({
  form: 'AdminInvite',
  destroyOnUnmount: true,
  enableReinitialize: true,
  pure: true
})(EmailAdminInvite));